
<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                
                <v-col xl="4" lg="5" md="6" cols="12" class="d-flex justify-center flex-column">
                <div>
                    <h2 class="section__header-title text-h3 font-weight-bold">Security & Sovereignty</h2>
                    <div>
                        <v-list class="features grey-card">
                            <v-list-item v-for="item in items" :key="item.title">
                                <v-list-item-icon>
                                    <v-icon color="primary">mdi-{{ item.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    <v-list-item-text>{{ item.text }}</v-list-item-text>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                </div>
                </v-col>
                <v-col xl="4" lg="4" md="6" col="12" class="text-center my-auto">

                    <h1 class="text-h1 font-weight-bold mb-3">5+ Years</h1>
                    <p>delivering secure, enterprise-grade communication systems to government and enterprise clients across Australia.</p>


                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'GovSecurity',
    data: () => ({
        items: [
            {
                title: 'Australian Owned & Operated', 
                text: 'All data stays onshore, hosted and supported in Brisbane.',
                icon: 'office-building'
            },
            {
                title: 'Security-First Design', 
                text: 'Data is encrypted at rest and in transit, with annual penetration tests and quarterly reviews.',
                icon: 'lock'
            },
            {
                title: 'Enterprise-Grade Reliability', 
                text: 'Built to handle sustained loads and unexpected traffic bursts without disruption.',
                icon: 'lightning-bolt'
            },

        ]
    })

}
</script>

<style lang="scss" scoped>
</style>